import { render, staticRenderFns } from "./cardVirtualAssistantUpdate.vue?vue&type=template&id=199184f1"
import script from "./cardVirtualAssistantUpdate.vue?vue&type=script&lang=js"
export * from "./cardVirtualAssistantUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports